import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import "./AdminLog.css";

const API_BASE = process.env.REACT_APP_API_BASE ;
const OTP_EXPIRY = 120;

export default function AdminResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || "";

  const [otp, setOtp] = useState("");
  const [passwords, setPasswords] = useState({ new_password: "", confirm_password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [timer, setTimer] = useState(OTP_EXPIRY);

  useEffect(() => {
    if (timer <= 0) return;
    const interval = setInterval(() => setTimer(prev => prev - 1), 1000);
    return () => clearInterval(interval);
  }, [timer]);

  const formatTime = () => {
    const m = Math.floor(timer / 60);
    const s = timer % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!otp) return setError("Please enter the OTP code sent to your email.");
    if (passwords.new_password !== passwords.confirm_password)
      return setError("Passwords do not match.");

    setLoading(true);
    try {
      await axios.post(`${API_BASE}/auth/reset-password/`, {
        email,
        otp,
        new_password: passwords.new_password,
      });

      setSuccess("Password has been reset successfully. Please log in with your new password.");
      setTimeout(() => navigate("/admin/login"), 2000);
    } catch (err) {
      console.error(err.response?.data);
      setError(err.response?.data?.error || "Failed to reset password. Please check your OTP and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <button className="back-btn" onClick={() => navigate(-1)}>✕</button>

        <h1>Reset Password</h1>
        <p className="subtitle">Enter the OTP sent to <b>{email}</b> and set a new password.</p>

        {error && <div className="alert error-alert">{error}</div>}
        {success && <div className="alert success-alert">{success}</div>}

        <form onSubmit={handleReset}>
          <input
            type="text"
            placeholder="OTP Code"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="New Password"
            value={passwords.new_password}
            onChange={(e) => setPasswords({ ...passwords, new_password: e.target.value })}
            required
          />
          <input
            type="password"
            placeholder="Confirm New Password"
            value={passwords.confirm_password}
            onChange={(e) => setPasswords({ ...passwords, confirm_password: e.target.value })}
            required
          />

          <div className="otp-timer">OTP expires in: <b>{formatTime()}</b></div>

          <button type="submit" disabled={loading || timer <= 0}>
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
}
